import React, { useState } from "react";
import { Pencil, Check } from "lucide-react";

// Inline-editable save name: shows name (or fallback) with a pencil; Enter/blur commits.
export const SaveName = ({ name, fallback, onRename, placeholder, testid, onClick }) => {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(name || "");
  const commit = () => {
    setEditing(false);
    const v = val.trim();
    if (v !== (name || "")) onRename(v);
  };
  if (editing) {
    return (
      <span className="flex min-w-0 flex-1 items-center gap-1">
        <input autoFocus value={val} maxLength={60} placeholder={placeholder} data-testid={`${testid}-input`}
          onChange={(e) => setVal(e.target.value)} onBlur={commit}
          onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") { setVal(name || ""); setEditing(false); } }}
          className="min-w-0 flex-1 rounded-md border border-xmas-gold/40 bg-xmas-navy/60 px-2 py-0.5 text-sm text-xmas-snow focus:border-xmas-gold focus:outline-none" />
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={commit} data-testid={`${testid}-commit`} className="rounded-full p-1 text-xmas-gold hover:bg-xmas-gold/15"><Check className="h-3.5 w-3.5" /></button>
      </span>
    );
  }
  return (
    <span className="flex min-w-0 flex-1 items-center gap-1">
      <button type="button" onClick={onClick} className="min-w-0 flex-1 truncate text-left text-sm text-xmas-snow" data-testid={testid}>{name || fallback}</button>
      <button type="button" onClick={(e) => { e.stopPropagation(); setVal(name || ""); setEditing(true); }} data-testid={`${testid}-edit`} aria-label="rename"
        className="shrink-0 rounded-full p-1 text-xmas-slate opacity-70 transition hover:bg-xmas-gold/15 hover:text-xmas-gold hover:opacity-100">
        <Pencil className="h-3 w-3" />
      </button>
    </span>
  );
};
